'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _NitroGrids = require('./NitroGrids');

var _NitroGrids2 = _interopRequireDefault(_NitroGrids);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _NitroGrids2.default;


//////////////////
// WEBPACK FOOTER
// ./~/nitro-components/build/nitro/nitro-grids/index.js
// module id = 104
// module chunks = 4